// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}\n._zulputpp{gap:var(--ds-space-150,9pt)}._189ee4h9{border-width:var(--ds-border-width,1px)}\n._1dqonqa1{border-style:solid}\n._1h6dmuej{border-color:var(--ds-border,#091e4224)}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._2lx21bp4{flex-direction:column}\n._4cvr1y6m{align-items:flex-start}", ""]);
// Exports
module.exports = exports;
